import '../../Default.css'
import './Recommend.css'
import { Flex } from "antd";
import { FC } from "react";
import { ServiceCategory } from "../../types";
import { RecommendCard } from "./RecommendCard";
import { recommendations } from '../../contents/recommendations';
import { useResponxiveContext } from '../../context/responsive-context';

export const Recommend: FC<{ category: ServiceCategory }> = ({ category }) => {
  const { isMobile, useVertical } = useResponxiveContext()
  return (
    <div className="Recommend-container">
    <h3 className="Recommend-header">{ recommendations[category].header }</h3>
    <div className="Recommend-cards-container">
    { isMobile &&
      <Flex className="Recommend-cards-mobile" justify={'space-between'} align={'center'} vertical={true}>
        {
          recommendations[category].bubbles.map(bubble => <RecommendCard { ...bubble }/>)
        }
      </Flex>
    }
    { !isMobile && useVertical &&

      <Flex className="Recommend-cards-vertical" justify={'space-between'} align={'center'} vertical={true} style={{backgroundImage:
        'url("https://storage.googleapis.com/simonadelstyle/color-2.jpg")',
    backgroundSize: '100%'
      }}>
        {
          recommendations[category].bubbles.map(bubble => <RecommendCard { ...bubble }/>)
        }
      </Flex>
    }
    { !useVertical &&
    <Flex justify={'space-evenly'} gap={'middle'}>
      <Flex className="Recommend-picture-container" justify={'start'}>
        <img className="Recommend-picture" src={recommendations[category].picture} />
      </Flex>

      <Flex className="Recommend-cards" justify={'space-between'} vertical={true}>
        {
          recommendations[category].bubbles.map(bubble => <RecommendCard { ...bubble }/>)
        }
      </Flex>
    </Flex>
    }
    </div>
    </div>
  )
}
